var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-deleted-container"},[_vm._v(" Your Trove account has been deleted click "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("here")]),_vm._v(" to navigate to the home page ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }